import React from 'react';
import styles from './styles';
import {ResponsiveContext} from '../../Context/ResponsiveContext';
import {UserContext} from '../../Context/UserContext';
import {InstanceContext} from '../../InstanceContext';
import trialSettings from '../TrialUI/trialSettings';
import ConsoleLinks from './ConsoleLinks';
import UserInfo from './UserInfo';
import Descriptions from './Descriptions';
import axiosConfig from '../../config/axios.config'
import axios from 'axios';

const HomePage = props => {

  const [admins, setAdmins] = React.useState(null)
  const {columns, device} = React.useContext(ResponsiveContext);
  const {user, userAction} = React.useContext(UserContext);
  const {contextInstance} = React.useContext(InstanceContext);

  const {tabs, instances} = trialSettings;
  const currentInstance = user.accountType === 'PI' ? 'PI' : contextInstance || user.instance;
  const tabIds = (instances[currentInstance] || instances.default).tabs;
  let thisInstanceTabs = {
    Trials: ['allTrials', 'conditions', 'getTrials', 'addTrials', 'excludeTrials', 'studyContacts', 'specialtyContacts', 'studyLocation', 'bulkUploads'], // removed 'customDescription' , 'priorityTrials'
    Patients: ['xpertTriage', 'myPatients', 'searchPatients', 'emailRecords','surveyQuestions'],
  };

  Object.keys(thisInstanceTabs).forEach(section => {
    thisInstanceTabs[section] = thisInstanceTabs[section].map(id => {
      if (tabIds.includes(id)) {
        return [id, tabs[id]];
      }
      return null;
    }).filter(val => val !== null);
  })

  const isNotMobile = device !== 'mobile';

  if (!admins) axios.get(`${axiosConfig.apiUrl}/rt/fetchAdmins/${currentInstance === 'PI' ? user.instance : currentInstance}`)
    .then(result => setAdmins(result.data))
    .catch(err =>console.log(err));


  return(
    <div style={styles.container}>
      <div style={{...styles.clearfix, ...styles.panelContainer, ...styles.fillHeightContainer}}>
        <div style={{
            ...columns.oneThird,
            padding: isNotMobile ? 0 : '0 10px 0 0',
            ...styles.fillHeightPanel,
            position: isNotMobile ? 'absolute' : 'static',
            marginBottom: isNotMobile ? 0 : '12px',
            overflowY: 'scroll',
            background: 'rgb(255, 255, 255)'

          }}>
          <div style={styles.panel}>
            <h4 style={styles.panelTitle}>Admins</h4>
            {(admins && admins.length !== 0) && <React.Fragment>
              {admins.map((user, key) => <UserInfo key={key} user={user}/>)}
            </React.Fragment>}
          </div>
        </div>
        <div style={{
            ...columns.twoThirds,
            ...styles.fillHeightStaticPanel,
            padding: isNotMobile ? '0 10px' : '0 10px 0 0',
          }}>
          <div style={styles.panel}>
            <h4 style={styles.panelTitle}>Console Links</h4>
            <ConsoleLinks
              trialTabs={thisInstanceTabs}
              columns={columns}
              instance={currentInstance}
              trueInstance={contextInstance || user.instance}
              history={props.history}
              user={user}
            />
          </div>
        </div>
      </div>
      <div style={{...styles.panel, margin: '0 10px 0 0'}}>
        <h4 style={styles.panelTitle}>Helpful Information</h4>
        <Descriptions
          links={tabIds}
          tabSettings={tabs}
          columns={columns}
        />
      </div>
    </div>
  );
}

export default HomePage;
